import React, { useState, useEffect } from "react";
import "../Styles/mobile-res.css";
import "../Styles/style.css";
import config from "../config";

const CompanyProcess = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const [bannerData, setBannerData] = useState(null);
  const [contentData, setContentData] = useState([]);
  const [faqs, setFaqs] = useState([]);

  useEffect(() => {
    // Fetch banner
    fetch(`${config.API_BASE_URL}/banners/process`)
      .then((res) => res.json())
      .then((data) => {
        if (data?.banners?.length > 0) {
          setBannerData(data.banners[0]);
        }
      })
      .catch((err) => console.error("Error fetching process banner:", err));

    // Fetch content
    fetch("/prosapiens-cms/public/api/content/process")
      .then((res) => res.json())
      .then((data) => {
        if (data?.content?.length > 0) {
          const sorted = [...data.content].sort(
            (a, b) => Number(a.content_order) - Number(b.content_order)
          );
          setContentData(sorted);
        }
      })
      .catch((err) => console.error("Error fetching process content:", err));

    // Fetch FAQs dynamically for "process" page
    fetch("/prosapiens-cms/public/api/content/faqs")
      .then((res) => res.json())
      .then((data) => {
        if (data?.content?.length > 0) {
          const filtered = data.content
            .filter((item) => item.link_url === "process")
            .sort((a, b) => Number(a.content_order) - Number(b.content_order))
            .map((item, index) => ({
              q: `${index + 1}. ${item.content_title}`,
              a: item.content_text.replace(/<\/?[^>]+(>|$)/g, ""), // remove HTML tags
            }));
          setFaqs(filtered);
        }
      })
      .catch((err) => console.error("Error fetching process FAQs:", err));
  }, []);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <>
      {/* Banner Section */}
      <section
        className="for-companies-process-desk process-mobil-1"
        style={{
          backgroundImage: bannerData?.banner_image
            ? `url(/prosapiens-cms/public/${bannerData.banner_image})`
            : "none",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="overlay container">
          <div className="hero-text">
            {bannerData?.content_text && (
              <div
                style={{ color: "#fff" }}
                dangerouslySetInnerHTML={{ __html: bannerData.content_text }}
              />
            )}
          </div>
        </div>
      </section>

      {/* WHAT WE DO */}
      {contentData
        .filter((sec) => sec.content_order === "1")
        .map((section) => {
          const imgUrl = section.content_image
            ? `/prosapiens-cms/public/${section.content_image}`
            : null;

          return (
            <section key={section.id} className="what-we-do">
              <div className="container">
                <div className="image-container">
                  {imgUrl && (
                    <div className="image-side" data-aos="fade-right">
                      <img src={imgUrl} alt={section.content_title} />
                    </div>
                  )}
                  <div
                    className="text-side"
                    data-aos="fade-left"
                    dangerouslySetInnerHTML={{ __html: section.content_text }}
                  />
                </div>
              </div>
            </section>
          );
        })}

      {/* SMART HIRING PROCESS */}
      {contentData
        .filter((sec) => sec.content_order === "2")
        .map((section) => (
          <div key={section.id} className="container">
            <section className="smart-hiring-process">
              <div dangerouslySetInnerHTML={{ __html: section.content_text }} />
            </section>
          </div>
        ))}

      {/* PROSAPIENS ADVANTAGE — wrap case 3,4,5 together */}
      {contentData.some((sec) =>
        ["3", "4", "5"].includes(sec.content_order)
      ) && (
        <section className="proSapiens">
          <div className="container">
            {contentData
              .filter((sec) => ["3", "4", "5"].includes(sec.content_order))
              .map((section) => {
                const imgUrl = section.content_image
                  ? `/prosapiens-cms/public/${section.content_image}`
                  : null;

                return (
                  <div
                    key={section.id}
                    className={`adv-page-${section.content_order}`}
                  >
                    <div className="image-container">
                      {/* Alternate layout */}
                      {(section.content_order === "3" ||
                        section.content_order === "5") &&
                        imgUrl && (
                          <div className="image-side" data-aos="fade-right">
                            <img src={imgUrl} alt={section.content_title} />
                          </div>
                        )}

                      <div
                        className="text-side"
                        data-aos={
                          section.content_order === "4"
                            ? "fade-left"
                            : "fade-right"
                        }
                        dangerouslySetInnerHTML={{
                          __html: section.content_text,
                        }}
                      />

                      {section.content_order === "4" && imgUrl && (
                        <div className="image-side" data-aos="fade-right">
                          <img src={imgUrl} alt={section.content_title} />
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
          </div>
        </section>
      )}

      <div className="divider"></div>

      {/* FAQ Section */}
      <div className="container">
        <div className="faq-wrapper">
          <div className="faq-left">FAQ -</div>
          <div className="faq-right">
            {faqs.length > 0 ? (
              faqs.map((faq, idx) => (
                <div className="faq-item" key={idx}>
                  <div
                    className={`faq-question${
                      activeIndex === idx ? " active" : ""
                    }`}
                    onClick={() => toggleFAQ(idx)}
                  >
                    {faq.q}
                    <span className="faq-icon">
                      {activeIndex === idx ? "–" : "+"}
                    </span>
                  </div>
                  <div
                    className={`faq-answer${
                      activeIndex === idx ? " active" : ""
                    }`}
                  >
                    {faq.a}
                  </div>
                </div>
              ))
            ) : (
              <p>No FAQs found for this page.</p>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default CompanyProcess;
